/**
 * AI service-suggestion → landing-page route map, shared by SearchDialog and
 * DashboardSearch (previously two byte-identical copies).
 */
export const SERVICE_SUGGESTION_ROUTES: Record<string, string> = {
  'childcare': '/childcare',
  'elderly-care': '/elderly-care',
  'cleaning': '/cleaning',
  'tutoring': '/tutoring',
  'pet-care': '/pet-care',
  'security': '/security',
  'handyman': '/maintenance',
  'gardening': '/gardening',
  'moving': '/services/moving',
  'errands': '/services/errands',
  'beauty-salon': '/services/beauty-salon',
  'video-services': '/services/video-services',
};
